<template>
  <div class="book-card-audio">
    <sample-audio-player
      :book-slug="bookSlug"
      block-name="book-card-player"
      event-name="body-20190328-book_card_audio_player"
      @play="onPlayerPlay"
      @pause="onPlayerPause"
      ref="player"
    />
    <div class="book-card-audio__label" v-html="label" />
  </div>
</template>

<script>
import SampleAudioPlayer from "@/shared/audio-player/sample-audio-player"

export default {
  name: "BookCardAudio",
  components: { SampleAudioPlayer },
  props: {
    bookSlug: { type: String, default: null },
    label: { type: String, default: null },
    onPlay: { type: Function, default: null },
    eventName: { type: String, default: null },
    eventPayload: { type: String, default: null }
  },

  data() {
    return { audioUrl: null }
  },

  methods: {
    play() {
      this.$refs.player.play()
    },

    pause() {
      this.$refs.player.pause()
    },

    onPlayerPlay() {
      if (this.onPlay) {
        this.onPlay()
        this.playerPlay = true
      }
    },

    onPlayerPause() {
      if (this.onPause) {
        this.onPause()
        this.playerPause = true
      }
    }
  }
}
</script>

<style lang="scss">
.book-card-audio {
  position: relative;

  padding: 0 $basex2 $basex2;

  &__label {
    @include font-family(sans-serif);
    @include font-style(legal);

    position: absolute;
    top: $base;
    left: base(10); // $basex8 + $basex2

    color: $grey;
  }
}

.book-card-player {
  $root: &;

  @include font-family(sans-serif);
  @include font-style(caption);

  display: flex;
  align-items: center;

  &__element {
    &--play {
      width: $basex6;
      height: $basex6;
      margin-right: $basex2;

      border: 4px solid $grey-pale;
      border-radius: 50%;
    }

    &--progress {
      flex-grow: 1;
      margin-right: $basex2;
    }

    &--total {
      color: $grey;

      @include media(max-width, m) {
        padding-right: 0;
      }
    }

    &:not(&--play) {
      margin-top: $basex2;
    }
  }

  &__play {
    display: block;

    width: 100%;
    height: 100%;

    background-color: transparent;
    background-image: url("~@images/book-card-player/play.svg");
    background-repeat: no-repeat;
    background-position: 60% 50%;

    border: 0;

    cursor: pointer;

    &:hover {
      background-image: url("~@images/book-card-player/play-hover.svg");
    }
  }

  &__pause {
    background-image: url("~@images/book-card-player/pause.svg");
    background-position: center;

    &:hover {
      background-image: url("~@images/book-card-player/pause-hover.svg");
    }
  }

  &__remaining-time {
    min-width: 3em;
  }

  &__progress {
    width: 100%;
  }

  .ranger {
    padding: 0;

    &__path {
      height: 5px;

      background: $grey-pale;
    }
  }
}
</style>
